import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { createPermission, editPermission, getActivePermissions,
deletePermission, getInactivePermissions } from '../../actions/permissionsAction'
import { Translate } from '../../../language';
import inMemoryJWT from '../../../auth/inMemoryJwt';

const PermissionAdmin = ({ history, createPermission, getActivePermissions, getInactivePermissions, deletePermission, editPermission, listActivePermission, isLoadinglistActivePermission, isLoadinglistInactivePermission, listInactivePermission }) => {

    useEffect(() => {
        if(!(inMemoryJWT.getToken())){
            inMemoryJWT.getRefreshedToken()
        }

        inMemoryJWT.waitForTokenRefresh().then(() => {
            getActivePermissions()
        getInactivePermissions()
        })
        
    },[])

    const [isEdit, setIsEdit] = useState(false)
    const [idEdit, setIdEdit] = useState('')
    const [indexEdit, setIndexEdit] = useState('')
    const [namePermission, setNamePermission] = useState('')
    const [description, setDescription] = useState('')
    const [isEnable, setEnable] = useState(false)
    const [isValidate, setValidate] = useState(false)
    const [error, setError] = useState({})

    const isFocused = (e) => {
        const { name } = e.target;
        setError(prevError => ({
            ...prevError,
            [name]: ''
        }));
    }

    const isEmpty = (e) => {
        if (description !== '' && namePermission !== '') {
            setValidate(true)
        }
        const { name, placeholder, value } = e.target;
        if (value.length === 0) {
            setValidate(false)
            setError(prevError => ({
                ...prevError,
                [name]: Translate('missingField', 'es') + placeholder
            }));
        }
        if (value.length !== 0) {

            setError(prevError => ({
                ...prevError,
                [name]: ''
            }));
        }

    }


    return (
        <div className="container-mark-type-admin">
            <div className="new-edit-type-mark-container-admin">
                <div className='title-admin'>{`${isEdit ? 'Editar' : 'Nuevo'} permiso en comunidades`}</div>
                <div className="container-inputs-new-mark">
                    <div className="text-input-admin">
                        {'Nombre:'}
                    </div>
                    <input
                        name='namePermission'
                        className='inputs-admin'
                        value={namePermission}
                        onChange={(e) => {
                            setNamePermission(e.target.value.trimStart())
                            if (namePermission !== '' && description !== '') {
                                setValidate(true)
                            }
                        }}
                        onBlur={e => isEmpty(e)}
                        onFocus={e => isFocused(e)}
                        onKeyUp={e => isEmpty(e)}
                    />
                    <div className="text-error text-error-admin">{error.name}</div>
                    <div className="text-input-admin">
                        {'Descripción:'}
                    </div>
                    <input
                        name='description'
                        className='inputs-admin'
                        value={description}
                        onChange={(e) => {
                            setDescription(e.target.value.trimStart())
                            if (description !== '' && namePermission !== '') {
                                setValidate(true)
                            }
                        }}
                        onBlur={e => isEmpty(e)}
                        onFocus={e => isFocused(e)}
                        onKeyUp={e => isEmpty(e)}
                    />
                    <div className="text-error text-error-admin">{error.description}</div>

                    {isEdit ?
                        <div className="content-buttom-create-admin">
                            <button className={`btns-admin btn-create-edit btns-admin-inactive`} onClick={() => {
                                setNamePermission('')
                                setDescription('')
                                setEnable(false)
                                setIdEdit('')
                                setIndexEdit('')
                                setIsEdit(false)
                            }}>
                                {Translate('cancel', 'es')}
                            </button>
                            <div className="ml-1 mr-1"></div>
                            <button disabled={isValidate ? '' : 'disabled'}
                                className={`btns-admin btn-create-edit ${isValidate ? '' : 'btns-admin-inactive'}`} onClick={() => {
                                    editPermission({ name: namePermission.trim(), description: description.trim(), id: idEdit, isEnabled: isEnable }, history, undefined, indexEdit)
                                    setNamePermission('')
                                    setDescription('')
                                    setEnable(false)
                                    setIdEdit('')
                                    setIndexEdit('')
                                    setIsEdit(false)
                                }}>
                                {Translate('edit', 'es')}
                            </button>
                        </div>

                        :
                        <div className="content-buttom-create-admin">
                            <button disabled={isValidate ? '' : 'disabled'}
                                className={`btns-admin btn-create-edit ${isValidate ? '' : 'btns-admin-inactive'}`} onClick={() => { createPermission({ name: namePermission.trim(), description: description.trim() }, history) }}>
                                {Translate('create', 'es')}
                            </button>
                        </div>
                    }
                </div>
            </div>
            <div className="see-all-mark-type-admin">
                <div className='title-admin-list'>Permisos habilitados</div>
                <div className='wrapper-2 column-gap row-gap mt-3'>
                    {isLoadinglistActivePermission ? <div>Cargando...</div> :
                        listActivePermission.map((permission, index) => (
                            <div key={permission._id} className="card-admin">
                                <div className="tittle-card-admin">{permission.name}</div>
                                <div className="text-content-card ">{permission.description}</div>
                                <div className="column centerContent">
                                    <div className="btns-admin ml-1 mr-1" onClick={() => {
                                        setNamePermission(permission.name)
                                        setDescription(permission.description)
                                        setEnable(permission.isEnable)
                                        setIdEdit(permission._id)
                                        setIndexEdit(index)
                                        setIsEdit(true)
                                    }}>Editar</div>
                                    <div className="btns-admin btns-admin-red" onClick={() => { deletePermission(permission._id, index, 'activePermissions') }}>Eliminar</div>
                                    <div className="btns-admin ml-1 btns-admin-inactive" onClick={() => { editPermission({ id: permission._id, isEnabled: false }, history, 'deactivate', index) }}>Desactivar</div>
                                </div>
                            </div>
                        ))
                    }
                </div>
                <div className='title-admin-list mt-4'>Permisos deshabilitados</div>
                <div className='wrapper-2 column-gap row-gap mt-3'>
                    {isLoadinglistInactivePermission ? <div>Cargando...</div> :
                        listInactivePermission.map((permission, index) => (
                            <div key={permission._id} className="card-admin">
                                <div className="tittle-card-admin">{permission.name}</div>
                                <div className="text-content-card ">{permission.description}</div>
                                <div className="column centerContent">
                                    <div className="btns-admin ml-1 mr-1" onClick={() => {
                                        setNamePermission(permission.name)
                                        setDescription(permission.description)
                                        setEnable(permission.isEnable)
                                        setIdEdit(permission._id)
                                        setIndexEdit(index)
                                        setIsEdit(true)
                                    }}>Editar</div>
                                    <div className="btns-admin btns-admin-red" onClick={() => { deletePermission(permission._id, index, 'inactivePermissions') }}>Eliminar</div>
                                    <div className="btns-admin ml-1 btns-admin-inactive" onClick={() => { editPermission({ id: permission._id, isEnabled: true }, history, 'activate', index) }}>Activar</div>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        isLoadinglistActivePermission: state.permissionsAdmin.isLoadinglistActivePermission,
        listActivePermission: state.permissionsAdmin.listActivePermission,
        isLoadinglistInactivePermission: state.permissionsAdmin.isLoadinglistInactivePermission,
        listInactivePermission: state.permissionsAdmin.listInactivePermission
    }
}


export default connect(mapStateToProps, { createPermission, editPermission, getActivePermissions, deletePermission, getInactivePermissions })(PermissionAdmin)